var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "App",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Hotel-Admin---Manage-Payout",
    transform: "translate(-965.000000, -205.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Title",
    transform: "translate(247.000000, 183.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "np_download_1161316_000000",
    transform: "translate(718.000000, 22.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,9.89035714 C18,9.53501786 17.7124725,9.2475 17.3571429,9.2475 C17.0018132,9.2475 16.7142857,9.5350275 16.7142857,9.89035714 L16.7142857,15.0332143 C16.7142857,15.3734786 16.5786814,15.701175 16.3376036,15.9422464 C16.0965257,16.1833179 15.7700893,16.3189286 15.4285714,16.3189286 L2.57142857,16.3189286 C1.86078214,16.3189286 1.28571429,15.7426071 1.28571429,15.0332143 L1.28571429,9.89035714 C1.28571429,9.53501786 0.998186786,9.2475 0.642857143,9.2475 C0.2875275,9.2475 0,9.5350275 0,9.89035714 L0,15.0332143 C0,15.7149964 0.271205357,16.3691357 0.753364286,16.8512786 C1.23552321,17.3334214 1.88967857,17.6046429 2.57142857,17.6046429 L15.4285714,17.6046429 C16.1103536,17.6046429 16.7644929,17.3334375 17.2466357,16.8512786 C17.7287786,16.3691196 18,15.7149643 18,15.0332143 L18,9.89035714 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,0 C8.64466071,0 8.35714286,0.2875275 8.35714286,0.642857143 L8.35714286,10.1889643 L5.328675,7.44679286 C5.06249357,7.20948857 4.65441429,7.23208821 4.41588214,7.49827286 C4.17857786,7.76445429 4.2011775,8.17378714 4.46736214,8.41106571 L8.56943357,12.1139229 L8.60459143,12.1428013 L8.65230429,12.1779559 L8.71006179,12.2106002 L8.76154179,12.2357118 L8.83185429,12.2583121 L8.87956714,12.2583121 L8.88082264,12.2595679 C8.96117979,12.2758904 9.04530407,12.2758904 9.12566121,12.2595679 L9.17337407,12.2595679 L9.24368657,12.2369673 L9.29516657,12.2118557 L9.35292407,12.1792114 L9.40063693,12.1440536 L9.43579479,12.1151751 L13.5327234,8.40235371 C13.798908,8.16379264 13.8215076,7.75573586 13.5842034,7.48956086 C13.3456423,7.22212264 12.9375855,7.199523 12.6714105,7.43808086 L9.64294264,10.1890594 L9.64294264,0.642952286 C9.64294264,0.472193357 9.5751405,0.308955857 9.45460479,0.188420143 C9.33406907,0.0678844286 9.17084443,8.22857143e-05 9.00007264,8.22857143e-05 L9,0 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.2fddbfc80d76bcc9a1d3d0375fb4c0f9.svg";
export { ForwardRef as ReactComponent };